import { ILabel } from "@hulanbv/platformapp";
import { CrudService } from "nest-utilities-client";
import { environment } from "../../constants/environment.constants";
import { httpService } from "../common/http.service";

class Service extends CrudService<ILabel> {
  constructor() {
    super([environment.apiUrl, "labels"].join("/"), httpService);
  }
}

export const labelService = new Service();
